module.exports = __webpack_public_path__ + "static/media/2.ca549293.png";